import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import { ButtonArrowLeft, ButtonArrowRight } from '../ButtonArrows';

const Tabs = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  margin: 0 ${rem('-15px')};

  ${mediaqueries.lessThan('mobile')`
      display: block;
      width: 100%;
      margin: inherit;
    }
  `};
  ${mediaqueries.greaterThan('tablet')`
    margin: 0;
    &:before {
      bottom: 0;
      content: '';
      display: block;
      left: 0;
      position: absolute;
      width: 100%;
    }
  `};
  ${mediaqueries.greaterThan('desktop')`
      transition: transform 0.5s ease-in-out;
      transform: translateX(${props => props.posX}px);
      margin: 0;
    }
  `};
`;

/**
 * Main wrapper
 */
const NavTabs = styled.nav`
  display: flex;
  width: 100%;
  align-items: center;
  // overflow: auto;

  ${props =>
    props.left &&
    `
          &:before {
            content: none;
          }
    `};

  ${props =>
    props.right &&
    `
      &:after {
        content: none;
      }
    `};

  ${mediaqueries.greaterThan('tabletLandscape')`

    &:before,
    &:after {
      content: none;
    }

    & ${Tabs}{
      display: flex;
      justify-content: space-between;
    }
  `};
`;

const NavTabsWithButtons = NavTabs.extend`
  background-color: ${props => props.theme.colors.dark};

  &:before,
  &:after {
    content: none;
  }

  ${mediaqueries.greaterThan('mobile')`
    background-color: transparent;
  `};
`;

/**
 * Buttons
 */
const buttons = `
  position: relative;
  width: ${rem('9px')};
  height: ${rem('18px')};
`;

const ButtonLeft = styled(ButtonArrowLeft)`
  ${buttons};
  left: ${rem('35px')};
  ${mediaqueries.greaterThan('mobile')`
    display: none;
  `};
`;
const ButtonRight = styled(ButtonArrowRight)`
  ${buttons};
  right: ${rem('35px')};
  ${mediaqueries.greaterThan('mobile')`
    display: none;
  `};
`;

export { NavTabs, NavTabsWithButtons, Tabs, ButtonLeft, ButtonRight };
